/**
 * @file use-stock-label-qty.ts
 * @description Количество этикеток у отмеченных строк остатка (phase19.22,
 *   W17-9c; ui-design §2): по умолчанию — остаток партии, развес — одна на
 *   тару; кладовщик правит степпером.
 *
 * Храним только правки: строка без правки берёт значение по умолчанию от
 * СВЕЖЕГО остатка — после перечитывания списка число не протухает.
 */

import { useCallback, useState } from "react";

import { stockDefaultLabelQty } from "./stock-label-print";
import type { StockLevelDto } from "../../../lib/api-wms";

export function useStockLabelQty() {
  const [edits, setEdits] = useState<ReadonlyMap<string, number>>(() => new Map());

  const qtyOf = useCallback(
    (level: StockLevelDto) => edits.get(level.id) ?? stockDefaultLabelQty(level),
    [edits],
  );

  const setQty = useCallback((level: StockLevelDto, qty: number) => {
    setEdits((prev) => new Map(prev).set(level.id, qty));
  }, []);

  const reset = useCallback(() => setEdits(new Map()), []);

  return { qtyOf, setQty, reset };
}
